import { Component } from "react";

import { cn } from "@btnet/utilities-core";

import "./ButtonEmbedded.less";

interface IButtonEmbeddedProps
    extends Omit<
        React.DetailedHTMLProps<React.HTMLAttributes<HTMLSpanElement>, HTMLSpanElement>,
        "role" | "onClick" | "onKeyUp"
    > {
    children: React.ReactNode;
    // Copied these types here because React doesn't combine default props with Html props very well
    onClick: (event: React.MouseEvent<HTMLSpanElement>) => void;
    onKeyUp: (event: React.KeyboardEvent<HTMLSpanElement>) => void;
    onActionPerformed: (
        event: React.MouseEvent<HTMLSpanElement> | React.KeyboardEvent<HTMLSpanElement>,
    ) => void;
    disabled?: boolean;
}

const spaceKey = 32;
const enterKey = 13;

/**
 * This is NOT a normal button.  Do not use unless you verify that it fits your requirements.
 * This component is only to be used when a button-like behaviour is required but the elements do not look like buttons.
 */
export class ButtonEmbedded extends Component<IButtonEmbeddedProps> {
    static defaultProps = {
        onClick: () => {},
        onKeyUp: () => {},
    };

    private onClick = (e: React.MouseEvent<HTMLSpanElement>) => {
        if (this.props.disabled) {
            return;
        }
        this.props.onClick(e);
        this.props.onActionPerformed(e);
    };

    private onKeyUp = (e: React.KeyboardEvent<HTMLSpanElement>) => {
        if (this.props.disabled) {
            return;
        }
        this.props.onKeyUp(e);
        if (e.keyCode === spaceKey || e.keyCode === enterKey) {
            this.props.onActionPerformed(e);
        }
    };

    render() {
        const {
            children,
            className,
            tabIndex,
            onKeyUp,
            onClick,
            onActionPerformed,
            disabled,
            ...restProps
        } = this.props;

        return (
            <span
                {...restProps}
                className={cn("ButtonEmbedded", className)}
                role="button"
                tabIndex={tabIndex || 0}
                onKeyUp={this.onKeyUp}
                onClick={this.onClick}
            >
                {children}
            </span>
        );
    }
}
